import Vue from 'vue'
import i18n from '@/languages'
import router from '@/router'
import app from '@/main'

const editRuleModule = {
  namespaced: true,
  state: {
    products: [],
    categories: null,
    pagination_products: null,
    businessRule: {
      name: '',
      rule_type: null
    },
    source: {},
    loadingProducts: false,
    loadingRule: false
  },

  mutations: {
    setProducts: (state, products) => (state.products = products),
    setCategories: (state, categories) => (state.categories = categories),
    setPaginationProducts: (state, pagination) => (state.pagination_products = pagination),
    setLoadingProducts: (state, loadingProducts) => (state.loadingProducts = loadingProducts),
    setLoadingRule: (state, loadingRule) => (state.loadingRule = loadingRule),
    setBusinessRule: (state, rule) => (state.businessRule = rule),
    setBusinessRuleName: (state, name) => (state.businessRule.name = name),
    setBusinessRuleId: (state, id) => (state.businessRule.id = id),
    setRuleType: (state, type) => (state.businessRule.rule_type = type),
    setSource: (state, source) => (state.source = source)
  },

  getters: {
    getProducts: (state, getters) => {
      const result = []

      state.products.forEach((prod) => {
        getters.getCategories.forEach((cat) => {
          if (prod.category_id === cat.id) {
            result.push({ ...prod, category_name: cat.name })
          }
        })
      })

      return result
    },
    getCategories: (state) => {
      const result = []

      for (const [key, value] of Object.entries(state.categories)) {
        result.push({ id: value, name: key })
      }

      return result
    }
  },

  actions: {
    GET_BUSINESS_RULE: async (
      { commit, state, rootState, dispatch, getters, rootGetters },
      ruleId
    ) => {
      commit('setLoadingRule', true)
      try {
        const response = await Vue.http.get(
          `${rootGetters.getBackendUrl}/recommendations/business_rules/${ruleId}`,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.ok) {
          const rule = response.body.rule
          await dispatch('GET_CATEGORIES')

          // расширяем инфо о target по url_hash

          if (rule.rule_type === 'OFFER_TO_OFFER') {
            await Promise.all(
              rule.targets.map(async (el, idx) => {
                const productInfo = await dispatch('GET_PRODUCT_INFO_BY_URL_HASH', el.target)
                const categoryName = getters.getCategories.filter(
                  (cat) => cat.id === productInfo.category_id
                )[0].name
                productInfo.category_name = categoryName
                rule.targets[idx].target = productInfo
              })
            )
          }

          // добавляем имя категории в исходный продукт source

          if (rule.rule_type === 'OFFER_TO_OFFER' || rule.rule_type === 'OFFER_TO_CATEGORY') {
            let sourceProduct = await dispatch('GET_PRODUCT_INFO_BY_URL_HASH', rule.source)
            const categoryName = getters.getCategories.filter(
              (cat) => cat.id === sourceProduct.category_id
            )[0].name
            sourceProduct = { ...sourceProduct, category_name: categoryName }
            commit('setSource', sourceProduct)
          }

          // добавляем имя категории для target

          if (rule.rule_type === 'OFFER_TO_CATEGORY' || rule.rule_type === 'CATEGORY_TO_CATEGORY') {
            rule.targets = rule.targets.map((el) => {
              getters.getCategories.forEach((cat) => {
                if (el.target === cat.id) {
                  el.target = { id: el.target, name: cat.name }
                }
              })
              return el
            })
          }

          if (rule.rule_type === 'CATEGORY_TO_CATEGORY') {
            const sourceCategoty = getters.getCategories.filter((cat) => cat.id === rule.source)[0]
            commit('setSource', sourceCategoty)
          }

          commit('setBusinessRule', rule)
          commit('setLoadingRule', false)
        }
      } catch (e) {
        router.push({ name: 'ListBusinessRules' })
        app.$raven.captureException(e)
      }
    },
    CREATE_BUSINESS_RULE: async (
      { commit, state, rootState, dispatch, getters, rootGetters },
      body
    ) => {
      commit('setLoadingRule', true)
      try {
        const response = await Vue.http.post(
          `${rootGetters.getBackendUrl}/recommendations/business_rules`,
          body,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.ok) {
          commit('setBusinessRuleId', response.body.result.data.id)
          commit('setLoadingRule', false)
          app.$message('success', i18n.t('instruments.business_rules.rule_created'))
          router.replace({ name: 'EditRule', params: { id: response.body.result.data.id } })
        }
      } catch (e) {
        app.$raven.captureException(e)
        app.$message('danger', e.statusText)
      }
    },
    UPDATE_BUSINESS_RULE: async (
      { commit, state, rootState, dispatch, getters, rootGetters },
      { id, body }
    ) => {
      commit('setLoadingRule', true)
      try {
        const response = await Vue.http.patch(
          `${rootGetters.getBackendUrl}/recommendations/business_rules/${state.businessRule.id}`,
          body,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.ok) {
          app.$message('success', i18n.t('instruments.business_rules.rule_updated'))
          commit('setLoadingRule', false)
        }
      } catch (e) {
        app.$raven.captureException(e)
        app.$message('danger', e.statusText)
      }
    },
    GET_PRODUCT_INFO_BY_URL_HASH: async ({ rootGetters }, urlHash) => {
      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/offers`, {
          headers: rootGetters.getAllResponseHeaders,
          params: {
            page: 1,
            per_page: 1,
            sort_field: 'url_hash',
            sort_direction: 'asc',
            search: urlHash
          }
        })

        if (response.ok) {
          return response.body.offers[0]
        }
      } catch (e) {
        app.$raven.captureException(e)
      }
    },
    DELETE_BUSINESS_RULE: async ({ commit, state, rootState, rootGetters }, rule) => {
      commit('setLoadingRule', true)
      try {
        const response = await Vue.http.delete(
          `${rootGetters.getBackendUrl}/recommendations/business_rules/${rule.id}`,
          {
            headers: rootGetters.getAllResponseHeaders
          }
        )

        if (response.ok) {
          const rules = rootState.recommendations.listBusinessRules.rules.filter(
            (el) => el.id !== rule.id
          )
          commit('recommendations/listBusinessRules/setRules', rules, { root: true })
          commit('setLoadingRule', false)
          router.replace({ name: 'ListBusinessRules' })
          app.$message('success', i18n.t('instruments.business_rules.rule_removed'))
          return
        }

        app.$message('danger', response.body.result.message)
      } catch (e) {
        app.$message('danger', e.statusText)
        app.$raven.captureException(e)
      }
    },
    GET_PRODUCTS: async ({ commit, dispatch, state, getters, rootGetters }, params) => {
      commit('setLoadingProducts', true)
      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/offers`, {
          headers: rootGetters.getAllResponseHeaders,
          params: {
            page: params.page,
            per_page: params.per_page,
            sort_field: params.sort_field,
            sort_direction: params.sort_direction,
            search: params.search
          }
        })

        if (response.ok) {
          const paginationProducts = {
            ...response.body.pagination,
            total_count: response.body.pagination.total_pages * params.per_page
          }
          commit('setProducts', response.body.offers)
          commit('setPaginationProducts', paginationProducts)
        }

        if (!state.categories) {
          await dispatch('GET_CATEGORIES')
        }

        await dispatch('recommendations/listProductRecommendation/GET_ALL_SERVICES', null, {
          root: true
        })
        commit('setLoadingProducts', false)
      } catch (e) {
        app.$raven.captureException(e)
      }
    },
    GET_CATEGORIES: async ({ commit, rootGetters }) => {
      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/offers/categories`, {
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.ok) {
          commit('setCategories', response.body.categories)
        }
      } catch (e) {
        app.$raven.captureException(e)
      }
    }
  }
}

export default editRuleModule



// WEBPACK FOOTER //
// ./src/store/modules/recommendations/modules/edit_rule.js